/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  getCaptainAssistant(inboxId) {
    return axios.get(`${this.url}/${inboxId}/captain_assistant`);
  }

  setCaptainAssistant(inboxId, assistantId) {
    return axios.post(`${this.url}/${inboxId}/set_captain_assistant`, {
      assistant_id: assistantId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  analyzeCSATTemplateUtility(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template/analyze`, {
      template,
    });
  }

  resetSecret(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reset_secret`);
  }

  getMediaSyncManifest(inboxId, params = {}) {
    return axios.get(`${this.url}/${inboxId}/media_sync/manifest`, {
      params,
    });
  }

  updateMediaSyncStatuses(inboxId, statuses) {
    return axios.post(`${this.url}/${inboxId}/media_sync/statuses`, {
      statuses,
    });
  }

  registerMediaSyncDevice(inboxId, device) {
    return axios.put(`${this.url}/${inboxId}/media_sync/primary_device`, {
      device,
    });
  }

  getMessageSyncManifest(inboxId, params = {}) {
    return axios.get(`${this.url}/${inboxId}/message_sync/manifest`, {
      params,
    });
  }

  enableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/enable_whatsapp_calling`);
  }

  disableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disable_whatsapp_calling`);
  }

  setInboundCalls(inboxId, enabled) {
    return axios.post(`${this.url}/${inboxId}/set_inbound_calls`, {
      inbound_calls_enabled: enabled,
    });
  }

  zaloLoginQr(inboxId) {
    return axios.post(`${this.url}/${inboxId}/zalo/login_qr`);
  }

  zaloStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/zalo/status`);
  }

  zaloReconnect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/zalo/reconnect`);
  }

  zaloLogout(inboxId) {
    return axios.post(`${this.url}/${inboxId}/zalo/logout`);
  }

  zaloOauthUrl(inboxId) {
    return axios.get(`${this.url}/${inboxId}/zalo/oauth_url`);
  }

  zaloApi(inboxId, method, args = []) {
    return axios.post(`${this.url}/${inboxId}/zalo/api/${method}`, { args });
  }

  facebookPersonalLoginCookie(inboxId, cookie) {
    return axios.post(`${this.url}/${inboxId}/facebook_personal/login_cookie`, {
      cookie,
    });
  }

  facebookPersonalLoginPassword(inboxId, credentials) {
    return axios.post(
      `${this.url}/${inboxId}/facebook_personal/login_password`,
      credentials
    );
  }

  facebookPersonalVerify2FA(inboxId, code) {
    return axios.post(`${this.url}/${inboxId}/facebook_personal/verify_2fa`, {
      code,
    });
  }

  facebookPersonalStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/facebook_personal/status`);
  }

  facebookPersonalReconnect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/facebook_personal/reconnect`);
  }

  facebookPersonalLogout(inboxId) {
    return axios.post(`${this.url}/${inboxId}/facebook_personal/logout`);
  }

  zaloStickers(inboxId, query) {
    return axios.get(`${this.url}/${inboxId}/zalo/stickers`, {
      params: { query },
    });
  }
}

export default new Inboxes();
